import Vue from 'vue'
import VueRouter from 'vue-router';
import { Store } from 'vuex';
import {setTitleWithApp} from '@/utils/util'
var isWeta365 = window.location.href.indexOf('source=weta365') !== -1;
console.log('---isWeta365',isWeta365)
let titleMap={
    "/textToVideo":"小说推文",
    "/app":"元创岛",
    "/downloadApp":"元创岛",
    "/protocol":"元创岛",
    "/privacy":"元创岛",
    "/commonList":"元创岛",
    "/sdkList":"元创岛",
    "/feige/protocol":"跟飞哥学AI",
    "/feige/privacy":"跟飞哥学AI",
    "/feige/commonList":"跟飞哥学AI",
    "/feige/sdkList":"跟飞哥学AI",
    "/payMiddlePage": "元创岛",
    "/realPaySuccess": "元创岛",
    "/voiceClone": "元创岛",
    "/voicePaySuccess": "元创岛",
    "/extraList": "提取历史",
    "/fileExtract": "文案提取",
    "/accredit": "授权我的作品账号",
    "/activity": "我的账号",
    "/activityManager": "授权账号管理",
    "/leaderboard": "排行榜",
    "/textGenerate": "文案生成",
    "/textGenerateList": "生成历史",
    "/welfareCenter": "福利中心",
    "/signIn": "每日签到",
    "/exchangeBean": "魔豆兑换",
    "/welfareRules": "活动规则",
    "/welfareRecords": "获得/兑换记录",
    "/main": "元创岛",
    "/sameTemplate": "教程模版",
    "/my": "我的",
    "/works": "作品管理",
    "/brainHistory": '全部历史数据',
    /********** AI 小工具 **********/
    "/ai-gold-start": "黄金开场",
    "/ai-title": "智能标题",
    "/ai-description": "智能描述",
    "/ai-rewrite": "智能改写",
    "/ai-image": "文生图",
    "/ai-image-detail": "生图详情"
}

let weta365TitleMap={
    "/":"奇妙元",
    "/article":"奇妙元"
}
const saveRouterPath = (path) => {
    if (path) {
        let prePath = localStorage.getItem('curPath')
        localStorage.setItem('prePath', prePath)
        localStorage.setItem('curPath', path)
    }
}
export default function initRouter(router:VueRouter,store: Store<any>){
 let titleMaps = isWeta365?weta365TitleMap:titleMap;
    router.beforeEach((to, from, next) => {
        saveRouterPath(to.path)
        document.title =titleMaps[to.path] || to?.meta?.title ||to.name || ""
        setTitleWithApp()
         next()
    });
}
